import { useState } from 'react'
import { cn } from '@/shared/lib/utils'

/**
 * Another company's site icon through DuckDuckGo's icon service, so the
 * visitor's browser never calls competitor sites directly. Unknown sites
 * get the service's generic icon.
 */
export function siteIconUrl(domain: string): string {
  return `https://icons.duckduckgo.com/ip3/${encodeURIComponent(domain)}.ico`
}

type GtmCompanyLogoProps = {
  name: string
  logoUrl: string | null
  className?: string
}

/** The site's own icon, or its initial when the icon is missing or broken. */
export function GtmCompanyLogo({
  name,
  logoUrl,
  className,
}: GtmCompanyLogoProps) {
  const [failed, setFailed] = useState(false)
  const base = cn(
    'flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-lg border border-sidebar-border bg-white',
    className,
  )

  if (!logoUrl || failed) {
    return (
      <span
        className={cn(
          base,
          'bg-secondary text-base font-semibold text-foreground',
        )}
      >
        {name.charAt(0).toUpperCase()}
      </span>
    )
  }
  return (
    <span className={base}>
      <img
        src={logoUrl}
        alt=""
        referrerPolicy="no-referrer"
        className="size-full object-contain p-1"
        onError={() => setFailed(true)}
      />
    </span>
  )
}
